module.exports = __webpack_public_path__ + "img/icon_watch.fa01881e.svg";